import { render } from "./LikesItem.vue?vue&type=template&id=5363c114"
import script from "./LikesItem.vue?vue&type=script&lang=js"
export * from "./LikesItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__